import React from 'react'
import PropTypes from 'prop-types'
import { Toolbar, Typography, styled, Box, Button, Link } from '@mui/material'
import config from '../../config'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

const PREFIX = 'appbar'

const classes = {
  root: `${PREFIX}-root`,
  greyBg: `${PREFIX}-grey-bg`,
  logo: `${PREFIX}-logo`,
  leftContent: `${PREFIX}-left-content`,
  centerTitle: `${PREFIX}-center-title`,
  title: `${PREFIX}-title`,
  button: `${PREFIX}-button`,
  mobileStepper: `${PREFIX}-mobile-stepper`,
}

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(1.5, 10),
    minHeight: 'initial',
    background: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5, 2.5),
    },
  },

  [`&.${classes.greyBg}`]: {
    background: '#f5f5f5',
  },

  [`& .${classes.logo}`]: {
    height: theme.spacing(8),
    width: theme.spacing(8),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(6),
      width: theme.spacing(6),
    },
  },

  [`& .${classes.leftContent}`]: {
    marginRight: 'auto',
  },

  [`& .${classes.centerTitle}`]: {
    marginBottom: '0',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(2),
    },
  },

  [`& .${classes.title}`]: {
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
  },

  [`& .${classes.button} > h6`]: {
    fontWeight: '700',
  },
  [`& .${classes.button}:hover`]: {
    background: 'none',
  },
}))

M1AppBar.propTypes = {
  isGreyBg: PropTypes.bool,
  leftContent: PropTypes.element,
  centerTitle: PropTypes.element,
  rightContent: PropTypes.element,
}

export default function M1AppBar(props) {
  const { isGreyBg } = props

  return (
    <StyledToolbar
      className={
        isGreyBg ? [classes.root, classes.greyBg].join(' ') : classes.root
      }
      sx={{ justifyContent: { xs: 'space-between' } }}
    >
      <Link variant="button" href="/">
        <img
          className={classes.logo}
          src={`${config.PUBLIC_URL}/logo.png`}
          alt="logo"
        />
      </Link>
      <Typography variant="h4" sx={{ marginRight: 'auto' }}>
        Prepaid Registration
      </Typography>

      <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
        <Button
          variant="text"
          target="_blank"
          rel="noopener"
          href="https://www.m1.com.sg/Support/FAQ/prepaid-faq"
          startIcon={<ArrowBackIosIcon />}
          className={classes.button}
        >
          <Typography variant="subtitle2">FAQ</Typography>
        </Button>
        <Button
          variant="text"
          target="_blank"
          rel="noopener"
          href="https://www.m1.com.sg/Mobile/prepaid-plans"
          startIcon={<ArrowBackIosIcon />}
          className={classes.button}
        >
          <Typography variant="subtitle2">M1 website</Typography>
        </Button>
      </Box>
    </StyledToolbar>
  )
}
